export default __webpack_public_path__ + "static/media/CIVIL.fbb8b4e5.jpg";